// SPDX-FileCopyrightText: Copyright 2025 OP Financial Group (https://op.fi). All Rights Reserved.
//
// SPDX-License-Identifier: LicenseRef-OpAllRightsReserved

import React, { useContext } from 'react';
import message from '../../messages';
import { ContextWrapper } from '../../context/ContextWrapper';

const DigitalAgreementInformation: React.FC = () => {
    const { isAdminFlow } = useContext(ContextWrapper);
    return (
        <div className="first-page-agreement-info-texts" data-testid="agreement-info-texts">
            {!isAdminFlow ? <h2 className="opux-spacing-top-margin-double">{message('companyServices')}</h2> : null}
            <p data-testid="digital-agreement-info-text-part1">{message('digitalAgreementInfoTextPart1')}</p>
            <p data-testid="digital-agreement-info-text-part2">{message('digitalAgreementInfoTextPart2')}</p>
        </div>
    );
};

export default DigitalAgreementInformation;
